import BaseFormPresenter from "../../../../../../../components/common/BaseFormPresenter";

class AllowanceBeniFormPresenter extends BaseFormPresenter {
  constructor(view) {
    super(view);
    this.view = view;
  }
}
export default AllowanceBeniFormPresenter;
